import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { TranslateService } from '@ngx-translate/core';
import { ProgressBarModule } from 'primeng/progressbar';


@Component({
  selector: 'app-dialog-loader',
  templateUrl: './dialog-loader.component.html',
  styleUrls: ['./dialog-loader.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    ProgressBarModule 
  ]
})
export class DialogLoaderComponent implements OnInit {
  public message!: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {message: string},
    private readonly translate: TranslateService,
    
  ) {

  }

  ngOnInit(): void {
    this.message = this.data.message || this.translate.instant('loader.default-title');
  }
}
